import { Script } from 'gatsby';
import React, { useEffect, useState } from 'react';

export const GtmScript = () => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const timeout = setInterval(() => {
            if (localStorage.getItem('consentGranted')) {
                clearInterval(timeout);

                setIsLoaded(true);
            }
        }, 100);

        return () => {
            clearInterval(timeout);
        };
    }, []);

    return (
        <>
            <Script strategy="idle">
                {`
                    window.dataLayer = window.dataLayer || [];
                    window.gtag = function() { dataLayer.push(arguments); };
                    gtag('consent', 'default', {
                        ad_storage: 'denied',
                        ad_user_data: 'denied',
                        ad_personalization: 'denied',
                        analytics_storage: 'denied',
                        functionality_storage: 'denied',
                        personalization_storage: 'denied',
                        security_storage: 'granted',
                        wait_for_update: 500
                    });
                    gtag('js', new Date());
                `}
            </Script>

            {isLoaded && <Script strategy="idle" src="https://www.googletagmanager.com/gtm.js?id=GTM-MSHLS9" />}
        </>
    );
};
